import React from 'react'
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai'
import { Container, Wrapper, IconBox, Icon, IconLink, Rights } from './FooterElements'


const Footer = () => {


    return (
        <Container>
            <Wrapper>
                <IconBox>
                    <Icon>
                        <IconLink href="https://github.com/abuiko" aria-label="Link to GitHub" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                            <AiFillGithub style={{ marginRight: "10px" }} />
                        </IconLink>
                    </Icon>
                    <Icon>
                        <IconLink href="https://www.linkedin.com/in/alenabuiko" aria-label="Link to LinkedIn" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                            <AiFillLinkedin />
                        </IconLink>
                    </Icon>
                </IconBox>
                <Rights>&copy; Alena Buiko 2022 - All Rights Reserved</Rights>
            </Wrapper>
        </Container>
    )
}

export default Footer
